import { useEffect, useState } from "react";
import { faSave, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Modal } from "react-bootstrap";
import { ButtonSpinner } from "../../../../../../../components/ButtonSpinner/ButtonSpinner";
import { InputText } from "../../../../../../../components/Inputs";
import { getParseDate, isStatusSucess } from "../../../../../../../helpers/helpers";
import { useForm } from "../../../../../../../hooks/useForm";
import { useValidator } from "../../../../../../../hooks/useValidator";
import { useLang } from "../../../../../../../language";
import { DiaFestivoServices } from "../../services/diasfestivos.service";
import { ModalStatusServer } from "../../../../../../../components/Modals/ModalStatusServer";
import { cloneDeep } from "lodash";

export const ModalDiaFestivo = ({ showModal_Evento, handleCloseModal_Evento, setEvents, events, fetchSuccess }: any) => {

    const Lang = useLang()

    const [activeideventofecha, setactiveideventofecha] = useState('')

    const [formDatosGenerales, handleInputDatosGenerales, handleFormDatosGenerales, resetDatosGenerales] = useForm({
        horainicio: '',
        horafin: '',
        title: Lang('EVENTO'),
    })

    const [valuesValidationEvento, handleValidationEvento, handleResetValidationEvento] = useValidator({
        descripcion: { isOk: true, msgError: [Lang('ALERT_OBLIGATORIO_GENERICO')] },
    })

    const [fetchFechaPOST, fetchFechaPOSTData] = DiaFestivoServices.POST()

    const handleGuardarEvento = (data: any) => {

        if (handleValidationEvento(formDatosGenerales)) {

            const dateStartTemp = new Date(data.start)

            fetchFechaPOST({
                body: {
                    ...formDatosGenerales,
                    fecha: getParseDate(dateStartTemp)
                }
            })
        }
    }

    useEffect(() => {

        if (isStatusSucess(fetchFechaPOSTData.status)) {

            const item = fetchFechaPOSTData.data?.data

            const fechTempStart = new Date(item.fecha + 'T00:00:00')
            const fechTempEnd = new Date(item.fecha + 'T00:00:00')

            setEvents((prev: any) => {

                return ([...prev, {
                    start: fechTempStart,
                    end: fechTempEnd,
                    title: item.descripcion,
                }])
            })

            handleCloseModal_Evento()
        }
    }, [fetchFechaPOSTData])

    // ---------------- PATCH Fechas festivas

    const [fetchFechaPATCH, fetchFechaPATCHData] = DiaFestivoServices.PATCH(showModal_Evento.payload?.fecha)
    
    const handlefetchFechaPATCH = () => {

        if (handleValidationEvento(formDatosGenerales)) {

            fetchFechaPATCH({
                body: {
                    ...formDatosGenerales,
                }
            })
        }
    }

    useEffect(() => {

        if (isStatusSucess(fetchFechaPATCHData.status)) {

            const eventsTemp = cloneDeep(events)

            eventsTemp.forEach((item: any) => {
                if (item.fecha === showModal_Evento.payload?.fecha) {
                    item.title = formDatosGenerales.descripcion
                    return
                }
            });

            setEvents(eventsTemp)

            handleCloseModal_Evento()
        }
    }, [fetchFechaPATCHData])

    // --------------- DELETE Horario Evento

    const [fetchFechaDELETE, fetchFechaDELETEData] = DiaFestivoServices.DELETE()

    const handlefetchFechaDELETE = (ideventofecha: any) => {
        
        setactiveideventofecha(ideventofecha)

        fetchFechaDELETE({
            id: ideventofecha
        })
    }

    useEffect(() => {

        if (isStatusSucess(fetchFechaDELETEData.status)) {

            setEvents(events?.filter((item: any) => item.fecha !== showModal_Evento.payload?.fecha))
            // resetDatosGenerales()
            setactiveideventofecha('')

            handleCloseModal_Evento()

            // fetchHorariosGET()
        }
    }, [fetchFechaDELETEData])


    useEffect(() => {

        if (showModal_Evento.value) {

            handleFormDatosGenerales({
                ...showModal_Evento.payload
            })
        }

    }, [showModal_Evento.value])

    return (
        <>
            <Modal className='ModalStatusServer' show={showModal_Evento.value} onHide={handleCloseModal_Evento} size='lg'>
                <Modal.Header closeButton className='border-0'>
                    <Modal.Title className='h5'>{Lang('DIA_FESTIVO')}</Modal.Title>
                </Modal.Header>
                <Modal.Body className='px-3 px-lg-4 pt-2'>

                    <div className="row">

                        <Form.Group className="col-12">
                            <InputText
                                label={Lang('DESCRIPCION') + ':'}
                                name='descripcion'
                                value={formDatosGenerales.descripcion}
                                onChange={handleInputDatosGenerales}
                                validation={valuesValidationEvento}
                            />
                        </Form.Group>

                    </div>

                </Modal.Body>

                <Modal.Footer className='border-0 d-flex justify-content-between'>

                    {
                        showModal_Evento.payload?.action === 'EDIT' &&
                        <>
                            <ButtonSpinner
                                variant="danger" type="button" className="text-nowrap"
                                handleSubmit={() => handlefetchFechaDELETE(showModal_Evento.payload?.fecha)} fetchDataLoading={[fetchFechaDELETEData.loading]}
                                value={Lang('ELIMINAR')} icon={<FontAwesomeIcon icon={faSave} className='me-1' />}
                            />
                            <ButtonSpinner
                                variant="secondary" type="button" className="text-nowrap"
                                handleSubmit={handlefetchFechaPATCH} fetchDataLoading={[fetchFechaPATCHData.loading]}
                                value={Lang('GUARDAR')} icon={<FontAwesomeIcon icon={faSave} className='me-1' />}
                            />
                        </>
                    }

                    {
                        showModal_Evento.payload?.action === 'CREATE' &&
                        <>
                            <div></div>
                            <ButtonSpinner
                                variant="secondary" type="button" className="text-nowrap"
                                handleSubmit={() => handleGuardarEvento(showModal_Evento.payload)} fetchDataLoading={[fetchFechaPOSTData.loading]}
                                value={Lang('CREAR')} icon={<FontAwesomeIcon icon={faSave} className='me-1' />}
                            />
                        </>
                    }

                </Modal.Footer>
            </Modal>

            <ModalStatusServer fetchData={fetchFechaPOSTData} />

            <ModalStatusServer fetchData={fetchFechaPATCHData} />

            <ModalStatusServer fetchData={fetchFechaDELETEData} />

        </>
    )
};
